import { useLang } from '@/i18n';
import EfSpec from '@elem/ui/ef-spec';
import EfImg from 'elem/ui/ef-img';
import { useRouter } from 'next/router';
import { imgLocale1 } from './imgs/Img1';
import { imgLocale2 } from './imgs/Img2';
import { imgLocale3 } from './imgs/Img3';
import { imgLocale4 } from './imgs/Img4';
import { imgLocale5 } from './imgs/Img5';
import { imgLocale6 } from './imgs/Img6';
import { imgLocale7 } from './imgs/Img7';
import { imgLocale8 } from './imgs/Img8';
import { imgLocale9 } from './imgs/Img9';
import styles from './index.module.scss';

export default function TheComp() {
    const { t } = useLang('delta3series');
    const { locale = 'us' } = useRouter();
    const IS_EU_SITES = ['eu', 'de', 'fr', 'it', 'es', 'uk', 'ph'].includes(locale);
    const img1 = imgLocale1[locale] || imgLocale1.us;
    const img2 = imgLocale2[locale] || imgLocale2.us;
    const img3 = imgLocale3[locale] || imgLocale3.us;
    const img4 = imgLocale4[locale] || imgLocale4.us;
    const img5 = imgLocale5[locale] || imgLocale5.us;
    const img6 = imgLocale6[locale] || imgLocale6.us;
    const img7 = imgLocale7[locale] || imgLocale7.us;
    const img8 = imgLocale8[locale] || imgLocale8.us;
    const img9 = imgLocale9[locale] || imgLocale9.us;

    const arr1 = [
        {
            pc: img1.pc,
            h5: img1.h5,
        },
        {
            pc: img2.pc,
            h5: img2.h5,
        },
        {
            pc: img3.pc,
            h5: img3.h5,
        },
        {
            pc: img4.pc,
            h5: img4.h5,
        },
        {
            pc: img5.pc,
            h5: img5.h5,
        },
        {
            pc: img6.pc,
            h5: img6.h5,
        },
        {
            pc: img7.pc,
            h5: img7.h5,
        },
        {
            pc: img8.pc,
            h5: img8.h5,
        },
        {
            pc: img9.pc,
            h5: img9.h5,
        },
    ];

    // const arr2 = [
    //     {
    //         pc: 'https://websiteoss.ecoflow.com/upload/image/1724935727766/a1.jpg',
    //         pad: 'https://websiteoss.ecoflow.com/upload/image/1724935727766/a1.jpg',
    //         h5: 'https://websiteoss.ecoflow.com/upload/image/1724936978031/b1.jpg',
    //     },
    //     {
    //         pc: 'https://websiteoss.ecoflow.com/upload/image/1724936476476/b2.jpg',
    //         pad: 'https://websiteoss.ecoflow.com/upload/image/1724936476476/b2.jpg',
    //         h5: 'https://websiteoss.ecoflow.com/upload/image/1724937165023/b2.jpg',
    //     },
    //     {
    //         pc: 'https://websiteoss.ecoflow.com/upload/image/1724936278621/b3.jpg',
    //         pad: 'https://websiteoss.ecoflow.com/upload/image/1724936278621/b3.jpg',
    //         h5: 'https://websiteoss.ecoflow.com/upload/image/1724937201102/b3.jpg',
    //     },
    //     {
    //         pc: 'https://websiteoss.ecoflow.com/upload/image/1724936201785/b4.jpg',
    //         pad: 'https://websiteoss.ecoflow.com/upload/image/1724936201785/b4.jpg',
    //         h5: 'https://websiteoss.ecoflow.com/upload/image/1724937127961/b4.jpg',
    //     },
    //     {
    //         pc: 'https://websiteoss.ecoflow.com/upload/image/1724936235454/b5.jpg',
    //         pad: 'https://websiteoss.ecoflow.com/upload/image/1724936235454/b5.jpg',
    //         h5: 'https://websiteoss.ecoflow.com/upload/image/1724936925306/b5.jpg',
    //     },
    //     {
    //         pc: 'https://websiteoss.ecoflow.com/upload/image/1724936161481/b6.jpg',
    //         pad: 'https://websiteoss.ecoflow.com/upload/image/1724936161481/b6.jpg',
    //         h5: 'https://websiteoss.ecoflow.com/upload/image/1724937230869/b6.jpg',
    //     },
    //     {
    //         pc: 'https://websiteoss.ecoflow.com/upload/image/1724936321853/b7.jpg',
    //         pad: 'https://websiteoss.ecoflow.com/upload/image/1724936321853/b7.jpg',
    //         h5: 'https://websiteoss.ecoflow.com/upload/image/1724937013899/b7.jpg',
    //     },
    //     {
    //         pc: 'https://websiteoss.ecoflow.com/upload/image/1724936441764/b8.jpg',
    //         pad: 'https://websiteoss.ecoflow.com/upload/image/1724936441764/b8.jpg',
    //         h5: 'https://websiteoss.ecoflow.com/upload/image/1724937055150/b8.jpg',
    //     },
    //     {
    //         pc: 'https://websiteoss.ecoflow.com/upload/image/1724936107916/b9.jpg',
    //         pad: 'https://websiteoss.ecoflow.com/upload/image/1724936107916/b9.jpg',
    //         h5: 'https://websiteoss.ecoflow.com/upload/image/1724937089560/b9.jpg',
    //     },
    // ];

    const arr = arr1;

    return (
        <div className={styles.TheComp}>
            <EfSpec className="spec-x" />
            <ul className={`items${IS_EU_SITES ? ' items-eu' : ''}`}>
                {arr?.map((item: any, k: number) => (
                    <li className={`item item${k + 1}`} key={k}>
                        <div className="item-img">
                            <EfImg pc={item.pc} pad={item.pad || item.pc} h5={item?.h5 || item?.pc} />
                            <div className="item-info">
                                <p className="item-name">
                                    {t.rich(`B_text${k + 1}_name`, {
                                        b: (tx: string) => <span className="blue">{tx}</span>,
                                        sup: (tx: string) => <sup className="sup">{tx}</sup>,
                                    })}
                                </p>
                                <p className="item-desc">
                                    {t.rich(`B_text${k + 1}_desc`, {
                                        sup: (tx: string) => <sup className="sup">{tx}</sup>,
                                    })}
                                </p>
                            </div>
                        </div>
                    </li>
                ))}
            </ul>
            {IS_EU_SITES && <p className="tip">{t('B_tip')}</p>}
            <EfSpec className="spec-x" />
        </div>
    );
}
